<template>
  <embedded-crud-table
    :entity="entity"
    :entity-store="entityStore"
    :columns="columns"
    :generate-summary="generateSummary"
    :definition="definition"
    :caption="caption"
    :disabled="disabled"
    :parent-id-filter-field="parentIdFilterField"
    :open-in-fullscreen="openInFullscreen"
    :required="required"
    :create-item-from-form-data="createItemFromFormData"
    :create-form-data-from-item="createFormDataFromItem"
    :permission-code="'ReasonStockCorrection'"
    :disable-filtering="true"
    :disable-sorting="true"
  />
</template>

<script>
import EmbeddedCrudTable from '@/components/crud/EmbeddedCrudTable';
import formMixin from './form-mixin';

export default {
  components: {
    EmbeddedCrudTable
  },
  mixins: [formMixin],
  props: {
    caption: String,
    parentIdFilterField: {
      type: String,
      required: true
    },
    disabled: {
      default: false,
      type: Boolean
    },
    openInFullscreen: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      columns: [
        { field: 'domainName', label: 'common.domain' },
        { field: 'code', label: 'common.code' }
      ]
    };
  },
  methods: {
    generateSummary(row) {
      const summary = `${row.domainName}`;
      return summary;
    }
  }
};
</script>

<style scoped></style>
